<div class="report-page-container">
    <div class="header-container">
      <div class="text-title-2">NDC Purchase Report</div>
    </div>
  
    <div class="table-controls-container">
      <form [formGroup]="controlsForm"
            [ngClass]="{'active': isUsersDropdownOpened || isDrugsDropdownOpened || isWholesalersDropdownOpened}"
      >
        <div class="period-picker-container">
          <app-date-filter 
            [period]="controlsForm.get('period')" 
            [customPeriod]="controlsForm.get('customPeriod')"
            [isLoading]="isLoading$ | async"
            >
          </app-date-filter>
        </div>
  
        <app-multiselect-dropdown formControlName="users"
                                  id="users"
                                  [id]="'users'"
                                  [ngClass]="{'actual': isUsersDropdownOpened}"
                                  [label]="'User'"
                                  [placeholder]="'All Users'"
                                  (dropDownOpened)="multiselectOpened('userItemsShowLimit', 'isUsersDropdownOpened')"
                                  (dropDownClosed)="multiselectClosed('userItemsShowLimit', 'isUsersDropdownOpened')"
                                  [data]="usersList"
                                  [settings]="userListSettings"
                                  [itemsLimit]="userItemsShowLimit"
                                  [loading]="isLoading$ | async"
                                  (tabEnterEvent)="focusMultioptionalDropdown('drugsMultioptionalDropdown')"
                                  #usersMultioptionalDropdown
        ></app-multiselect-dropdown>
  
        <app-multiselect-dropdown formControlName="drugs"
                                  id="drugs"
                                  [id]="'drugs'"
                                  [ngClass]="{'actual': isDrugsDropdownOpened}"
                                  [label]="'Drug'"
                                  [placeholder]="'All Drugs'"
                                  (dropDownOpened)="multiselectOpened('drugItemsShowLimit', 'isDrugsDropdownOpened')"
                                  (dropDownClosed)="multiselectClosed('drugItemsShowLimit', 'isDrugsDropdownOpened')"
                                  [data]="drugsList"
                                  [settings]="drugListSettings"
                                  [itemsLimit]="drugItemsShowLimit"
                                  [loading]="isLoading$ | async"
                                  [shouldFilterByNDC]="true"
                                  (tabEnterEvent)="focusMultioptionalDropdown('activityMultioptionalDropdown')"
                                  #drugsMultioptionalDropdown
        ></app-multiselect-dropdown>
  
        <app-multiselect-dropdown formControlName="wholesalers"
                                  id="wholesalers"
                                  [id]="'wholesalers'"
                                  [ngClass]="{'actual': isWholesalersDropdownOpened}"
                                  [label]="'Wholesaler'"
                                  [placeholder]="'All Wholesalers'"
                                  (dropDownOpened)="multiselectOpened('wholesalerItemsShowLimit', 'isWholesalersDropdownOpened')"
                                  (dropDownClosed)="multiselectClosed('wholesalerItemsShowLimit', 'isWholesalersDropdownOpened')"
                                  [data]="wholesalers$ | async"
                                  [settings]="wholesalerListSettings"
                                  [itemsLimit]="wholesalerItemsShowLimit"
                                  [loading]="isLoading$ | async"
                                  #wholesalersMultioptionalDropdown
        ></app-multiselect-dropdown>

        <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled$ | async"
          class="ml-2"
          label="Location"
          [control]="controlsForm.controls.inventoryLocations">
        </app-inventory-locations-filter>
      </form>
  
      <div class="header-controls">
        <app-button [text]="'Reset'"
                    styleClass="settings"
                    subStyle="blue"
                    customClasses="px-4 mr-2"
                    [minWidth]="0"
                    [disabled]="areFiltersEmpty() && !originalRecordsList?.length"
                    (clicked)="reset()"
        ></app-button>
        <app-button customClasses="px-4"
                    [text]="'Run Report'"
                    (clicked)="runReport()"
                    [loading]="runningReports$ | async"
        ></app-button>
      </div>
    </div>
  
    <div class="reports-table-container">
      <div *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && !isReportRun" class="empty-list-container">
        <div class="icon-wrapper">
          <img class="chart-icon" src="assets/icons/icon-chart-active.svg" alt="report-icon"/>
        </div>
        <div class="empty-list-header">Results</div>
        <div class="empty-list-description">
          Your report data will show up here.
        </div>
      </div>
  
      <app-empty-table *ngIf="(isLoading$ | async) !== true && !originalRecordsList?.length && isReportRun"
                       [labelValue]="'There are no items to display.'"
                       [topOffset]="290"
      ></app-empty-table>
  
      <form class="table-controls" *ngIf="originalRecordsList?.length">
        <div *ngIf="sortedRecordsList.length" class="right-block">
          <div class="heading">
            Results
          </div>
          <app-button [text]="'By NDC'"
                      styleClass="toggle"
                      [disabled]="isLoading$ | async"
                      [subStyle]="filterResultsBy === 'drug' ? 'active' : 'unactive'"
                      [minWidth]="0"
                      customClasses="px-3 mr-8"
                      (clicked)="switchFilterResultBy('drug')"
          ></app-button>
          <app-button [text]="'By Wholesaler'"
                      styleClass="toggle"
                      [disabled]="isLoading$ | async"
                      [subStyle]="filterResultsBy === 'wholesalerSupplier' ? 'active' : 'unactive'"
                      [minWidth]="0"
                      customClasses="px-3"
                      (clicked)="switchFilterResultBy('wholesalerSupplier')"
          ></app-button>
          <app-button [text]="'By Similar'"
                      styleClass="toggle"
                      [disabled]="isLoading$ | async"
                      [subStyle]="filterResultsBy === 'gpi' ? 'active' : 'unactive'"
                      [minWidth]="0"
                      customClasses="px-3 ml-8"
                      (clicked)="switchFilterResultBy('gpi')"
          ></app-button>
        </div>
      </form>

    <div class="flex flex-row tables-container">
      <table class="table-primary report-records-table sticky-table" *ngIf="originalRecordsList?.length">
        <thead>
          <tr>
            <th (click)="sortByColumn('transactionDate')"
                class="text-left sort recorded" scope="col"
            >
            DATE/TIME
              <img [class.asc]="tableColumns.transactionDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
            </th>
            <th *ngIf="filterResultsBy === 'wholesalerSupplier' || filterResultsBy === 'gpi'"
              class="text-left sort drug" scope="col" 
              (click)="sortByColumn('packageNdc')">
              Drug
              <img [class.asc]="tableColumns.packageNdc" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
            </th>
            <th class="text-left location" scope="col" *ngIf="inventoryLocationsEnabled$ | async">
              Location
            </th>
          </tr>
        </thead>
        <tbody #tbody [style.overflow]="'hidden'">
          <ng-container *ngFor="let group of sortedRecordsList; let i = index">
            <tr class="group-header-container" (click)="groupItemsOpened[i] = !groupItemsOpened[i]">
              <td colspan="8">
                <img [class.close]="!groupItemsOpened[i]" class="icon-toggle"
                     src="assets/icons/icon-toggle-chevron-green.svg"
                     alt="toggle-icon"/>
                <div class="group-header">
                  {{group.header}}
                </div>
              </td>
            </tr>
            <ng-container *ngIf="groupItemsOpened[i]">
              <tr class="table-row"
                  *ngFor="let ndcPurchaseRecord of group.transactions; trackBy: trackByFn;"
                  (click)="openOrder(ndcPurchaseRecord?.orderId)"
              >
                <td class="text-left recorded">
                  <div class="heading">
                    {{ndcPurchaseRecord?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
                  </div>
                  <div class="secondary">
                    {{ndcPurchaseRecord?.user}}
                  </div>
                </td>
                <th class="text-left drug" scope="row" *ngIf="filterResultsBy === 'wholesalerSupplier' || filterResultsBy === 'gpi'">
                  <div [title]="ndcPurchaseRecord['friendlyName']" class="heading">
                    {{ndcPurchaseRecord['friendlyName']}}
                  </div>
                  <div class="secondary">
                    {{ndcPurchaseRecord['packageNdc']}}
                  </div>
                </th>
                <td class="text-left location">
                  {{ndcPurchaseRecord?.locationName}}
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
  

    <div class="table-wrapper not-default-scrollbar">
      <table class="table-primary report-records-table second-table" *ngIf="originalRecordsList?.length" (scroll)="onScroll($event)" 
        appHorizontalOverflowClass>
        <thead>
        <tr>
          <th class="text-right starting" scope="col">
            Starting
          </th>
          <th class="text-right count" scope="col">
            Count
          </th>
          <th class="text-right on-hand" scope="col">
            On-hand
          </th>
          <th class="text-right on-hand" scope="col">
            SOH
          </th>
          <th *ngIf="filterResultsBy === 'drug' || filterResultsBy === 'gpi' "
            class="text-left sort wholesaler" scope="col"
            (click)="sortByColumn('wholesalerSupplier')">
            Wholesaler
            <img [class.asc]="tableColumns.wholesalerSupplier" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
          </th>
          <th class="text-left po" scope="col">
            PO Num
          </th>
          <th class="text-left info" scope="col">
            Invoice Num
          </th>
          <th class="text-left csos" scope="col">
            CSOS
          </th>
          <th class="text-left ship-date" scope="col">
            Ship Date
          </th>
        </tr>
        </thead>
        <tbody #tbody>
        <ng-container *ngFor="let group of sortedRecordsList; let i = index">
          <tr class="group-header-container" (click)="groupItemsOpened[i] = !groupItemsOpened[i]">
            <td colspan="8">
            
            </td>
          </tr>
  
          <ng-container *ngIf="groupItemsOpened[i]">
            <tr class="table-row"
                *ngFor="let ndcPurchaseRecord of group.transactions; trackBy: trackByFn;"
                (click)="openOrder(ndcPurchaseRecord?.orderId)"
            >
              <td class="text-right starting">
                {{ndcPurchaseRecord?.startingQuantity | number}}
              </td>
              <td class="text-right count">
                {{ndcPurchaseRecord?.addedQuantity | number}}
              </td>
              <td class="text-right on-hand">
                {{ndcPurchaseRecord?.endingQuantity | number}}
              </td>
              <td class="text-right on-hand">
                {{ndcPurchaseRecord?.similarOnHandEndingQuantity | number}}
              </td>
              <td class="text-left wholesaler" *ngIf="filterResultsBy === 'drug' || filterResultsBy === 'gpi'">
                {{ndcPurchaseRecord?.wholesalerSupplier}}
              </td>
              <td class="text-left po">
                {{ndcPurchaseRecord?.purchaseOrder}}
              </td>
              <td class="text-left info">
                {{ndcPurchaseRecord?.invoiceNumber}}
              </td>
              <td class="text-left csos">
                {{ndcPurchaseRecord?.csos}}
              </td>
              <td class="text-left ship-date">
                {{ndcPurchaseRecord?.shipDate | date : 'mediumDate' : 'UTC'}}
              </td>
            </tr>
          </ng-container>
  
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
    </div>
    <app-button *ngIf="sortedRecordsList?.length && originalRecordsList?.length"
      customClasses="ml-3 px-4 mr-3 flex-start min-w-[117px]" [text]="'Download'" appMenu [loading]="isFileDownloading"
      [minWidth]="117" justifyTextPosition="left" [autoClose]="'outside'"
      [menuContent]="downloadMenuContent" triggers="manual" #downloadMenu="appMenu"
      (click)="downloadMenu.toggle();$event.stopPropagation();" [ngClass]="(loadingLibertyRxInventory$ | async) ? 'download-btn-left' : 'download-btn'">
      <img [class.opened]="downloadMenu.isOpen()" class="download-btn-icon" src="assets/icons/icon-chevron-down-white.svg"
        alt="chevron-down" />
    </app-button>
    <ng-template #downloadMenuContent>
      <div class="menu-container primary">
        <div (click)="savePDF();downloadMenu.close();$event.stopPropagation()" class="menu-item">
          <div class="option">Export as PDF</div>
        </div>
        <div (click)="saveCSV();downloadMenu.close();$event.stopPropagation()" class="menu-item">
          <div class="option">Save as CSV</div>
        </div>
      </div>
    </ng-template>
  </div>
  